import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import {
  ITemplateRuleCondition,
  IConditionQuestionSet,
} from './ITemplateRuleCondition'
import { IProject } from '@core/entities/project/Project'

/**
 * Entity class representing a condition within a conditional logic rule.
 * Supports both same-stage and cross-stage conditional logic.
 */
export class TemplateRuleCondition extends Entity<ITemplateRuleCondition> {
  type?: 'QUESTION' | 'PROJECT_IS_IN' | null | undefined
  questionId?: string
  conjoiningOperator?: 'AND' | 'OR'
  terms?: Array<{ operator: 'IS'; answerId?: number | string }>
  projectIds?: number[]
  projects?: IProject[]
  /** For cross-stage conditional logic: identifies which question set this condition references */
  conditionQuestionSet?: IConditionQuestionSet

  public isAnswerUsedByTerm(answerId: string): boolean {
    if (this.type === 'PROJECT_IS_IN' || !this.terms) {
      return false
    }
    return this.terms.some((term) => term.answerId === answerId)
  }

  public static new(payload: unknown): TemplateRuleCondition {
    const entity = plainToInstance(TemplateRuleCondition, payload)

    return entity
  }
}
